import {FC} from 'react'
import Button from "../common/Button/Button";
import {useNavigate} from "react-router-dom";

interface Props {
    booking: Booking
    setBooking: Function,
    data: any
}

const HjulskifteBooking: FC<Props> = ({ booking, setBooking, data }) => {
    const navigate = useNavigate();
    const changeTime = () => {
        navigate('/datum')
    }

    if(!data.spot.date) {
        return (
            <>
                <h2>Dina uppgifter</h2>
                <table className="wc-booking-summary-list shop_table">
                    <tbody>
                    <tr>
                        <th>Namn</th>
                        <td>{data.customer.booking.name}</td>
                    </tr>
                    <tr>
                        <th>Telefon</th>
                        <td>{data.customer.booking.phone}</td>
                    </tr>
                    <tr>
                        <th>E-post</th>
                        <td>{data.customer.data.email}</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Gå vidare för att komplettera och skapa bokning.</td>
                    </tr>
                    </tbody>
                </table>
                <Button id="btn-change-time" className={'btn-booking-next btn btn-center btn--skyblue'} loading={false} title={'Gå vidare'} action={changeTime} active={true} />
            </>
        )
    }
    return (
        <>
            <h2>Bokningsförslag</h2>
            <table className="wc-booking-summary-list shop_table">
                <tbody>
                <tr>
                    <th>Datum</th>
                    <td>{data.spot.date}</td>
                </tr>
                <tr>
                    <th>Tid</th>
                    <td>{data.spot.time}</td>
                </tr>
                <tr>
                    <th>Plats</th>
                    <td>{data.customer.booking.place}</td>
                </tr>
                <tr>
                    <th>Namn</th>
                    <td>{data.customer.booking.name}</td>
                </tr>
                <tr>
                    <th>Telefon</th>
                    <td>{data.customer.booking.phone}</td>
                </tr>
                <tr>
                    <th>E-post</th>
                    <td>{data.customer.data.email}</td>
                </tr>
                <tr>
                    <td colSpan={2}>Gå vidare för att komplettera och skapa bokning.</td>
                </tr>
                </tbody>
            </table>
            <Button id="btn-change-time" className={'btn-booking-next btn btn-center btn--skyblue'} loading={false} title={'Ändra plats/tid'} action={changeTime} active={true} />
        </>
    )
};

export default HjulskifteBooking
